/* TEMPVS v7: normalize watch-case size & visual centre.
   Unlike CSS transform on variably sized product images, drawing into a
   square frame provides one exact origin for EVERY card. No original
   photographs are changed. ?tempvs_debug=1 reveals actual measurements. */
(() => {
  'use strict';
  const VERSION='16.0-another-25pct-larger-cases';
  const SELECTOR='.ProductItem__ImageWrapper[data-tempvs-watch-card]';
  const S=320,cache=new Map(),diameterCache=new Map();
  const debug=new URLSearchParams(location.search).has('tempvs_debug');
  const clamp=(n,min,max)=>Math.min(max,Math.max(min,n));
  const med=arr=>{
    if(!arr.length)return 0;
    const a=arr.slice().sort((a,b)=>a-b);
    return a[Math.floor((a.length-1)/2)];
  };

  function detect(imageData,photoX,photoY,photoW,photoH){
    const rgba=imageData.data,NP=S*S;
    const bx0=clamp(Math.round(photoX+4),0,S-1), bx1=clamp(Math.round(photoX+photoW-5),0,S-1);
    const by0=clamp(Math.round(photoY+4),0,S-1), by1=clamp(Math.round(photoY+photoH-5),0,S-1);
    const corners=[by0*S+bx0,by0*S+bx1,by1*S+bx0,by1*S+bx1];
    const alpha=corners.filter(i=>rgba[i*4+3]<70).length>=2;
    const bg=[0,1,2].map(k=>corners.reduce((s,i)=>s+rgba[4*i+k],0)/4);
    const spread=Math.max(...corners.map(i=>
      Math.abs(rgba[4*i]-bg[0])+Math.abs(rgba[4*i+1]-bg[1])+Math.abs(rgba[4*i+2]-bg[2])));
    /* tolerate mildly uneven photographic backgrounds */
    const lo=new Int16Array(S).fill(S),hi=new Int16Array(S).fill(-1);
    const X=[],Y=[],lum=new Float32Array(NP);
    let n=0;
    for(let y=0;y<S;y++)for(let x=0;x<S;x++){
      const i=y*S+x,k=4*i;
      lum[i]=.213*rgba[k]+.715*rgba[k+1]+.072*rgba[k+2];
      const difference=Math.abs(rgba[k]-bg[0])+Math.abs(rgba[k+1]-bg[1])+Math.abs(rgba[k+2]-bg[2]);
      const on=alpha?rgba[k+3]>100:rgba[k+3]>120&&difference>(rgba[k]+rgba[k+1]+rgba[k+2]>650?39:53);
      if(!on)continue;
      X.push(x);Y.push(y);n++;
      if(x<lo[y])lo[y]=x;
      if(x>hi[y])hi[y]=x;
    }
    if(n<NP*.004||n>NP*.85)return null;
    X.sort((a,b)=>a-b);Y.sort((a,b)=>a-b);
    const a=Math.floor((n-1)*.005),b=Math.floor((n-1)*.995);
    const left=X[a],right=X[b],top=Y[a],bottom=Y[b];
    const totalW=right-left+1,totalH=bottom-top+1;
    if(totalW<25||totalH<50||totalW>S*.99)return null;

    const width=new Float32Array(S),centres=new Float32Array(S);
    for(let y=0;y<S;y++)if(hi[y]>=lo[y]){
      width[y]=hi[y]-lo[y]+1;
      centres[y]=(hi[y]+lo[y])/2;
    }
    const smooth=new Float32Array(S);
    for(let y=0;y<S;y++){
      const k=[];for(let d=-3;d<=3;d++)if(y+d>=0&&y+d<S)k.push(width[y+d]);
      smooth[y]=med(k);
    }
    const first=clamp(Math.floor(top+totalH*.16),0,S-1);
    const last=clamp(Math.ceil(top+totalH*.84),0,S-1);
    const candidates=[];
    for(let y=first;y<=last;y++)if(smooth[y]>.35*totalW)candidates.push(smooth[y]);
    if(candidates.length<14)return null;
    candidates.sort((a,b)=>a-b);
    const approxCaseW=candidates[Math.floor(.87*(candidates.length-1))];
    if(approxCaseW<20||approxCaseW>S*.98)return null;

    // A watch case is an almost circular concentration of broad rows.
    // Compare both sides of each possible dial centre; bracelet rows and
    // the crown should not become the centre.
    const r=.5*approxCaseW;
    const rSteps=[0,.22,.42,.62,.80,1];
    const ideal=[1,.975,.91,.78,.60,.41];
    let bestY=null,bestScore=Infinity;
    for(let y=first;y<=last;y++){
      if(smooth[y]<approxCaseW*.7)continue;
      let score=0,asymmetry=0;
      for(let k=0;k<rSteps.length;k++){
        const d=Math.round(r*rSteps[k]);
        const wa=smooth[clamp(y-d,0,S-1)]/approxCaseW;
        const wb=smooth[clamp(y+d,0,S-1)]/approxCaseW;
        const weight=k<4?1:.65;
        score+=(Math.abs(clamp(wa,0,1.3)-ideal[k])+
                Math.abs(clamp(wb,0,1.3)-ideal[k]))*weight;
        asymmetry+=Math.abs(wa-wb);
      }
      score+=.22*asymmetry;
      score+=.25*Math.abs(y-(top+bottom)/2)/totalH;
      if(score<bestScore){bestScore=score;bestY=y;}
    }
    if(bestY===null)return null;
    const xSections=[];
    for(let y=Math.round(bestY-approxCaseW*.28);
        y<=Math.round(bestY+approxCaseW*.28);y++){
      if(y<0||y>=S)continue;
      if(width[y]>.7*approxCaseW&&width[y]<1.08*approxCaseW)xSections.push(centres[y]);
    }
    if(xSections.length<5)return null;
    const centreX=med(xSections);
    let centreY=bestY,refinedX=centreX,method='case';
    if(centreX<20||centreX>S-20)return null;

    // Optional robust dial/bezel circular boundary refinement.
    // Limited range excludes bracelet features and distant highlights.
    const gradient=(x,y)=>{
      const xx=Math.round(x),yy=Math.round(y);
      if(xx<2||xx>S-3||yy<2||yy>S-3)return 0;
      const k=yy*S+xx;
      return Math.abs(lum[k-1]-lum[k+1])+Math.abs(lum[k-S]-lum[k+S]);
    };
    const angles=Array.from({length:28},(_,i)=>2*Math.PI*i/28);
    function ring(cx,cy,r){
      let sum=0,hits=0;
      for(const angle of angles){
        const cs=Math.cos(angle),sn=Math.sin(angle);
        const x=cx+r*cs,y=cy+r*sn;
        const g=Math.max(gradient(x,y),gradient(x+2*cs,y+2*sn),gradient(x-2*cs,y-2*sn));
        sum+=Math.min(g,140);
        if(g>20)hits++;
      }
      return hits>=18?sum/28:0;
    }
    let original=0,bestRing=0,ringLocation=null;
    for(let radius=approxCaseW*.28;radius<=approxCaseW*.46;radius+=Math.max(2,approxCaseW*.045)){
      original=Math.max(original,ring(centreX,bestY,radius));
      for(let dy=-approxCaseW*.07;dy<=approxCaseW*.07;dy+=Math.max(2,approxCaseW*.035)){
        for(let dx=-approxCaseW*.07;dx<=approxCaseW*.07;dx+=Math.max(2,approxCaseW*.035)){
          const score=ring(centreX+dx,bestY+dy,radius);
          if(score>bestRing){bestRing=score;ringLocation=[centreX+dx,bestY+dy];}
        }
      }
    }
    if(ringLocation&&bestRing>29&&bestRing>original*1.20){
      refinedX=ringLocation[0];centreY=ringLocation[1];method='dial-ring';
    }
    // Case-width correction based on upper/lower case flanks (avoids crown).
    const sampleOffsets=[.13,.18,.23].map(k=>k*approxCaseW);
    const caseEstimates=[];
    for(const d of sampleOffsets){
      for(const sign of [-1,1]){
        const yy=Math.round(centreY+sign*d);
        if(yy<0||yy>=S||width[yy]<approxCaseW*.56)continue;
        const factor=Math.sqrt(Math.max(.2,1-Math.pow(2*d/approxCaseW,2)));
        const candidate=width[yy]/factor;
        if(candidate>.75*approxCaseW&&candidate<1.25*approxCaseW)caseEstimates.push(candidate);
      }
    }
    const caseWidth=caseEstimates.length>=3?med(caseEstimates):approxCaseW;
    if(caseWidth<18||caseWidth>S*.99)return null;
    return {x:refinedX,y:centreY,width:caseWidth,method,
      alpha,approxCaseW,sourceW:totalW};
  }

  function prepareWhiteBackground(ctx,region,pictureLeft,pictureTop,pictureW,pictureH){
    const data=ctx.getImageData(0,0,S,S),p=data.data;
    const x0=clamp(Math.floor(pictureLeft+2),0,S-1), x1=clamp(Math.ceil(pictureLeft+pictureW-3),0,S-1);
    const y0=clamp(Math.floor(pictureTop+2),0,S-1), y1=clamp(Math.ceil(pictureTop+pictureH-3),0,S-1);
    if(x1-x0<35||y1-y0<35)return false;
    const inds=[y0*S+x0,y0*S+x1,y1*S+x0,y1*S+x1];
    // An alpha source is already transparent, and mixed/dark corner photos
    // should retain their original background.
    if(inds.some(i=>p[i*4+3]<220))return false;
    const bg=[0,1,2].map(k=>med(inds.map(i=>p[4*i+k])));
    const spread=Math.max(...inds.map(i=>Math.abs(p[4*i]-bg[0])+Math.abs(p[4*i+1]-bg[1])+Math.abs(p[4*i+2]-bg[2])));
    const brightness=(bg[0]+bg[1]+bg[2])/3;
    if(brightness<218||spread>90)return false;
    const visited=new Uint8Array(S*S), queue=new Int32Array(S*S);
    let first=0,last=0;
    function push(x,y){
      if(x<x0||x>x1||y<y0||y>y1)return;
      const i=y*S+x;
      if(visited[i])return;
      const k=4*i;
      const lum=(p[k]+p[k+1]+p[k+2])/3;
      const delta=Math.abs(p[k]-bg[0])+Math.abs(p[k+1]-bg[1])+Math.abs(p[k+2]-bg[2]);
      if(lum<205||delta>82)return;
      visited[i]=1;queue[last++]=i;
    }
    for(let x=x0;x<=x1;x++){push(x,y0);push(x,y1);}
    for(let y=y0;y<=y1;y++){push(x0,y);push(x1,y);}
    if(last<50)return false;
    while(first<last){
      const i=queue[first++];
      const x=i%S,y=Math.floor(i/S);
      push(x-1,y);push(x+1,y);push(x,y-1);push(x,y+1);
    }
    const fraction=last/((x1-x0+1)*(y1-y0+1));
    if(fraction<.07||fraction>.88)return false;
    for(let i=0;i<last;i++)p[4*queue[i]+3]=0;
    ctx.putImageData(data,0,0);
    return true;
  }

  function measure(src){
    if(cache.has(src))return cache.get(src);
    const job=(async()=>{
      try{
        const image=new Image();
        image.crossOrigin='anonymous';image.decoding='async';image.src=src;
        await image.decode();
        if(!image.naturalWidth||!image.naturalHeight)return null;
        const buffer=document.createElement('canvas');
        buffer.width=buffer.height=S;
        const ctx=buffer.getContext('2d',{willReadFrequently:true});
        if(!ctx)return null;
        const fit=Math.min(S/image.naturalWidth,S/image.naturalHeight);
        const pictureW=image.naturalWidth*fit,pictureH=image.naturalHeight*fit;
        const pictureLeft=(S-pictureW)/2,pictureTop=(S-pictureH)/2;
        ctx.clearRect(0,0,S,S);
        ctx.drawImage(image,pictureLeft,pictureTop,pictureW,pictureH);
        const region=detect(ctx.getImageData(0,0,S,S),pictureLeft,pictureTop,pictureW,pictureH);
        if(!region){
          // Conservative fallback: no oversized raw photograph, even if
          // the exact case cannot be found reliably.
          return {image,region:{x:S/2,y:S/2,width:Math.max(22,pictureW*.65),
            method:'safe-fallback'},pictureW,pictureH,pictureLeft,pictureTop};
        }
        
        // For legacy opaque white-background photos, erase only the light
        // connected exterior. Never remove an enclosed pale dial.
        const clean=prepareWhiteBackground(ctx,region,pictureLeft,pictureTop,pictureW,pictureH);
        if(clean) return {image:buffer,region,pictureW:S,pictureH:S,pictureLeft:0,pictureTop:0};
        return {image,region,pictureW,pictureH,pictureLeft,pictureTop};
      }catch(_){return null;}
    })();
    cache.set(src,job);return job;
  }

  function diagnostic(wrapper,msg){
    if(!debug)return;
    let d=wrapper.querySelector('.TempvsSizeDebug');
    if(!d){d=document.createElement('span');d.className='TempvsSizeDebug';wrapper.appendChild(d);}
    d.textContent=msg;
  }

  function draw(wrapper,img,mm,result){
    if(!img.isConnected||!wrapper.isConnected)return;
    const slot=wrapper.querySelector('.AspectRatio');
    if(!slot)return;
    const frame=slot.getBoundingClientRect();
    const W=frame.width,H=frame.height;
    if(W<40||H<40)return;
    let canvas=slot.querySelector('canvas.TempvsWatchCanvas');
    if(!canvas){
      canvas=document.createElement('canvas');
      canvas.className='TempvsWatchCanvas';
      canvas.setAttribute('aria-hidden','true');
      slot.appendChild(canvas);
    }
    const dpr=Math.min(window.devicePixelRatio||1,3);
    canvas.width=Math.max(1,Math.round(W*dpr));
    canvas.height=Math.max(1,Math.round(H*dpr));
    const ctx=canvas.getContext('2d');
    if(!ctx)return;
    ctx.setTransform(dpr,0,0,dpr,0,0);
    ctx.clearRect(0,0,W,H);
    const {image,region,pictureW,pictureH,pictureLeft,pictureTop}=result;
    // Fixed target in ONE shared frame, never parent photo dimensions.
    const target=Math.min(W,H)*(.355*1.25*1.25)*(mm/40);
    const scale=target/region.width;
    // Position the detected DIAL or WATCH-HEAD centre at (50%,50%).
    const drawX=W/2-(region.x-pictureLeft)*scale;
    const drawY=H/2-(region.y-pictureTop)*scale;
    try {
      ctx.drawImage(image,drawX,drawY,pictureW*scale,pictureH*scale);
      // A replacement must genuinely contain watch detail. A missing image,
      // blank/white Shopify placeholder or a poor crop must NEVER hide the
      // original product photograph.
      const check=ctx.getImageData(0,0,canvas.width,canvas.height);
      const pixels=check.data;
      const stride=Math.max(1,Math.floor(Math.sqrt((canvas.width*canvas.height)/4800)));
      let visible=0,detail=0;
      for(let y=0;y<canvas.height;y+=stride){
        for(let x=0;x<canvas.width;x+=stride){
          const i=4*(y*canvas.width+x),alpha=pixels[i+3];
          if(alpha<70)continue;
          visible++;
          const r=pixels[i],g=pixels[i+1],b=pixels[i+2];
          if(Math.min(r,g,b)<180 || (r+g+b)<615)detail++;
        }
      }
      if(visible===0 || detail<25 || detail/Math.max(1,visible)<.016){
        wrapper.dataset.tempvsCalibrated='false';
        img.dataset.tempvsSizingStatus='original-visible-canvas-rejected';
        diagnostic(wrapper,mm+'mm original: canvas failed visible detail check');
        canvas.remove();
        return;
      }
    } catch(error){
      wrapper.dataset.tempvsCalibrated='false';
      img.dataset.tempvsSizingStatus='original-visible-canvas-error';
      diagnostic(wrapper,mm+'mm original: unable to draw calibrated watch');
      canvas.remove();
      return;
    }
    wrapper.dataset.tempvsCalibrated='true';
    img.dataset.tempvsSizingStatus='frame-centred';
    img.dataset.tempvsSizingVersion=VERSION;
    img.dataset.tempvsCasePx=target.toFixed(1);
    img.dataset.tempvsDialX='50%';
    img.dataset.tempvsDialY='50%';
    img.dataset.tempvsSizingMethod=region.method;
    diagnostic(wrapper,(wrapper.dataset.tempvsSizingAccuracy==='unverified'?'unverified':mm+'mm')+' '+Math.round(target)+'px centre 50/50 '+region.method);
    wrapper._tempvsCalibratedResult=result;
  }

  function setImage(wrapper,img,mm){
    // Use the product's own high-quality thumbnail URL. This makes calibration
    // independent from when Shopify/lazysizes decides to load the visible img.
    const src=wrapper.dataset.tempvsSource||img.currentSrc||img.src||'';
    if(!src)return;
    if(wrapper._tempvsCalibratingSrc===src&&wrapper._tempvsCalibratedResult)return;
    wrapper._tempvsCalibratingSrc=src;
    measure(src).then(result=>{
      if(!wrapper.isConnected||
        (wrapper.dataset.tempvsSource && wrapper.dataset.tempvsSource!==src)||
        (!wrapper.dataset.tempvsSource && (img.currentSrc||img.src)!==src))return;
      if(!result){
        wrapper.dataset.tempvsCalibrated='false';
        img.dataset.tempvsSizingStatus='original-unmeasurable';
        diagnostic(wrapper,mm+'mm original: source not measurable');
        return;
      }
      draw(wrapper,img,mm,result);
    });
  }

  /* Search results are generated by Boost, whose index can omit the case
     metafield. Read it from the current Shopify product view on demand,
     so future products work without manually maintaining a size lookup. */
  function findDiameter(wrapper,img) {
    if (wrapper.dataset.tempvsCaseMm || wrapper.dataset.tempvsDiameterLookup) return;
    const href=wrapper.getAttribute('href');
    if(!href)return;
    let url;
    try {
      url=new URL(href,location.origin);
      if(url.origin!==location.origin || !url.pathname.includes('/products/'))return;
      url.searchParams.set('view','tempvs-diameter');
      url.searchParams.delete('variant');
      // The active theme preview is maintained by Shopify's preview cookie.
    }catch(_){return;}
    wrapper.dataset.tempvsDiameterLookup='pending';
    const key=url.pathname;
    if(!diameterCache.has(key)){
      const promise=fetch(url.toString(),{credentials:'same-origin'})
        .then(resp=>resp.ok?resp.text():null)
        .then(body=>{
          if(!body)return null;
          let d;try{d=JSON.parse(body);}catch(_){return null;}
          const mm=Number(d.case_mm);
          return Number.isFinite(mm)&&mm>=25&&mm<=55?mm:null;
        }).catch(()=>null);
      diameterCache.set(key,promise);
    }
    diameterCache.get(key).then(mm=>{
      if(!wrapper.isConnected)return;
      if(!mm){wrapper.dataset.tempvsDiameterLookup='unknown';return;}
      wrapper.dataset.tempvsCaseMm=String(mm);
      wrapper.dataset.tempvsDiameterLookup='verified';
      wrapper.dataset.tempvsSizingAccuracy='diameter-recorded';
      if(wrapper._tempvsCalibratedResult) draw(wrapper,img,mm,wrapper._tempvsCalibratedResult);
      else setImage(wrapper,img,mm);
    });
  }

  function scan(){
    document.querySelectorAll(SELECTOR).forEach(wrapper=>{
      const measuredMm=Number(wrapper.dataset.tempvsCaseMm);
      const known=Number.isFinite(measuredMm)&&measuredMm>=25&&measuredMm<=55;
      const mm=known?measuredMm:40;
      wrapper.dataset.tempvsSizingAccuracy=known?'diameter-recorded':'unverified';
      const img=wrapper.querySelector('img.ProductItem__Image:not(.ProductItem__Image--alternate)')
        ||wrapper.querySelector('img.ProductItem__Image');
      if(!img)return;
      if(!known)findDiameter(wrapper,img);
      if(!wrapper._tempvsBound){
        wrapper._tempvsBound=true;
        img.addEventListener('load',()=>{
          wrapper._tempvsCalibratedResult=null;
          const fresh=Number(wrapper.dataset.tempvsCaseMm);
          setImage(wrapper,img,Number.isFinite(fresh)&&fresh>=25&&fresh<=55?fresh:40);
        });
        if('ResizeObserver' in window){
          const ro=new ResizeObserver(()=>{
            if(wrapper._tempvsCalibratedResult){
              const fresh=Number(wrapper.dataset.tempvsCaseMm);
              draw(wrapper,img,Number.isFinite(fresh)&&fresh>=25&&fresh<=55?fresh:40,wrapper._tempvsCalibratedResult);
            }
          });
          ro.observe(wrapper);
          wrapper._tempvsSizeObserver=ro;
        }
      }
      setImage(wrapper,img,mm);
    });
  }

  function boot(){
    scan();
    let queued=false;
    new MutationObserver(()=>{
      if(queued)return;queued=true;
      requestAnimationFrame(()=>{queued=false;scan();});
    }).observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();